import { connectHook } from 'app/common/components/connect-hook';
import { ToolEditor } from './tool-editor.js';
import { useToolEditor } from './tool-editor-hook.js';

export default connectHook(ToolEditor, useToolEditor);
